import React from "react";
import { format } from "date-fns";
import hu from "date-fns/locale/hu";

function toDecimal(value) {
  return (Math.round((value + Number.EPSILON) * 100) / 100).toFixed(2);
}

const styles = {
  deadlineList: {
    width: "100%",
    marginTop: 15,
    paddingLeft: 0,
  },

  deadlineListItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: 32,
    cursor: "pointer",
    paddingLeft: 10,
    paddingRight: 10,
  },

  deadlineListItemOdd: {
    backgroundColor: "#edecec",
  },

  deadlineListItemSpan: {
    display: "block",
    color: "#302f2b",
    fontSize: 15,
    fontWeight: "bold",
  },

  deadlineListItemDate: {
    width: 150,
    color: "#302f2b",
    fontWeight: "bold",
    fontSize: 15,
    textDecoration: "none",
    textAlign: "left",
  },

  deadlineListItemDecreased: {
    color: "#e40f0f",
  },

  deadlineListItemIncreased: {
    color: "#07761c",
  },
};

const DeadlineList = ({ isCBOT, deadlines, getRates }) => {
  return (
    <ul style={styles.deadlineList}>
      {deadlines.map((deadline, index) => {
        const selectedStyle = deadline.rate.didGrow
          ? styles.deadlineListItemIncreased
          : styles.deadlineListItemDecreased;

        const rowStyle = index % 2 === 0 ? styles.deadlineListItemOdd : {};

        return (
          <li
            style={{ ...styles.deadlineListItem, ...rowStyle }}
            key={index}
            onClick={(event) => getRates(event, deadline)}
          >
            <span style={styles.deadlineListItemDate} type="button">
              {format(new Date(deadline.date), "yyyy. MMMM", { locale: hu })}
            </span>
            <span style={{ ...styles.deadlineListItemSpan, ...selectedStyle }}>
              {isCBOT
                ? `${deadline.rate.usdDiff > 0 ? "+" : ""}${toDecimal(
                    deadline.rate.usdDiff
                  )}`
                : `${deadline.rate.eurDiff > 0 ? "+" : ""}${toDecimal(
                    deadline.rate.eurDiff
                  )}`}
            </span>
            <span style={styles.deadlineListItemSpan}>
              {isCBOT
                ? `${toDecimal(deadline.rate.usd)} ¢ / v`
                : `${toDecimal(deadline.rate.eur)} € / t`}
            </span>
          </li>
        );
      })}
    </ul>
  );
};

export default DeadlineList;
